/* eslint-disable */
export default function (context, inject) {
  if (typeof window !== 'undefined') {
    const stripePlugin = {
      import() {
        return window.Stripe && window.Stripe('pk_test_RkMiY1f2658ji6UKJUjFXRnT00Fwhxdhsr')
      },
    }

    inject('stripe', stripePlugin);
    context.app.stripe = stripePlugin;
  }
}